// src/services/menuService.js
// 菜單管理 — Admin API 客戶端（Plan 106 實作、098 共用）
// 對應後端 /api/menu/*（JWT + adminOnly）。一律 return res.data（gotcha #9）。
import apiService from './apiService';

const { apiRequest } = apiService;

// GET /api/menu/categories → { success, categories:[{id,name,sortOrder,isActive,items:[…]}] }
const listCategories = async () => {
  const res = await apiRequest('get', 'menu/categories');
  return res.data;
};

const createCategory = async (payload) => {
  const res = await apiRequest('post', 'menu/categories', payload);
  return res.data;
};

const updateCategory = async (id, patch) => {
  const res = await apiRequest('put', `menu/categories/${id}`, patch);
  return res.data;
};

const deleteCategory = async (id) => {
  const res = await apiRequest('delete', `menu/categories/${id}`);
  return res.data;
};

// body: { ids: [categoryId, …] } 期望順序
const reorderCategories = async (ids) => {
  const res = await apiRequest('put', 'menu/categories/reorder', { ids });
  return res.data;
};

const createItem = async (payload) => {
  const res = await apiRequest('post', 'menu/items', payload);
  return res.data;
};

const updateItem = async (id, patch) => {
  const res = await apiRequest('put', `menu/items/${id}`, patch);
  return res.data;
};

const deleteItem = async (id) => {
  const res = await apiRequest('delete', `menu/items/${id}`);
  return res.data;
};

// POST /api/menu/import  body: { text, commit }
// commit=false → 只回解析預覽 { categories, footnotes, total }；true → 寫入（回 created）
const importMenu = async (text, commit = false) => {
  const res = await apiRequest('post', 'menu/import', { text, commit });
  return res.data;
};

const menuService = {
  listCategories, createCategory, updateCategory, deleteCategory, reorderCategories,
  createItem, updateItem, deleteItem, importMenu
};
export default menuService;
